import styled from 'styled-components';

export const Style = styled.div`
  display: flex;
  gap: var(--size-lg);
  flex: 1;
  overflow-x: auto;

  .row-item {
    flex: 1; 
    background: #FFFFFF;
    border: 1px solid #EAECF0;
    box-shadow: 0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03);
    border-radius: 8px;
    padding: var(--size);
    display: flex;
    flex-direction: column;
    gap: 10px;
    min-width: 150px;
    
    .icon-cont {
      display: flex;
      justify-content: flex-end;

      .icon {
        background: #EFF8FF;
        border: 3px solid #F5FAFF;
        border-radius: 100px;
        width: 37px;
        height: 37px;
        display: flex;
        justify-content: center;

        img {
          width: 20px;
        }
      }
    }

    label {
      margin-bottom: 0px;
      color: #344054;
      font-size: var(--font-size-lg);
      font-weight: 700;
    }

    .label {
      margin-bottom: 0px;
      color: #344054;
      font-size: 14px;
      font-weight: 500;
    }
  }
`;
